import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { withAppContext } from '../Context';
import { DisabledRouterLink } from './NavLinkWithParams';

type SmartLinkProps = {
  to: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  data?: any;
};
const SmartLink: FC<SmartLinkProps> = ({ to, children, className, style, data }) => {
  const { disableRouter } = data || {};
  if (!to) return <>{children}</>;
  if (to.startsWith('http')) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" className={className} style={style}>
        {children}
      </a>
    );
  }

  return (
    <Link
      to={to}
      className={className}
      style={style}
      component={disableRouter ? DisabledRouterLink : undefined}
    >
      {children}
    </Link>
  );
};

export default withAppContext(SmartLink);
